import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { Toaster } from "sonner";
import ErrorBoundary from "./components/ErrorBoundary";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Articles from "./pages/Articles";
import ArticleEdit from "./pages/ArticleEdit";
import Scanner from "./pages/Scanner";
import Labels from "./pages/Labels";
import Lagerplan from "./pages/Lagerplan";
import Settings from "./pages/Settings";
import History from "./pages/History";
import Register from "./pages/Register";
import UsersAdmin from "./pages/UsersAdmin";
import Abhollager from "./pages/Abhollager";
import Projects from "./pages/Projects";
import Suppliers from "./pages/Suppliers";
import Orders from "./pages/Orders";
import Inventory from "./pages/Inventory";
import Groups from "./pages/Groups";

function App() {
  return (
    <div className="App" translate="no">
      <ErrorBoundary>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/registrieren" element={<Register />} />
              <Route path="/passwort-zuruecksetzen" element={<ResetPassword />} />
              <Route
                element={
                  <ProtectedRoute>
                    <ErrorBoundary>
                      <Layout />
                    </ErrorBoundary>
                  </ProtectedRoute>
                }
              >
                <Route path="/" element={<Dashboard />} />
                <Route path="/artikel" element={<Articles />} />
                <Route path="/artikel/neu" element={<ArticleEdit />} />
                <Route path="/artikel/:id" element={<ArticleEdit />} />
                <Route path="/gruppen" element={<Groups />} />
                <Route path="/scanner" element={<Scanner />} />
                <Route path="/abhollager" element={<Abhollager />} />
                <Route path="/projekte" element={<Projects />} />
                <Route path="/projekte/:name" element={<Projects />} />
                <Route path="/lieferanten" element={<Suppliers />} />
                <Route path="/bestellungen" element={<Orders />} />
                <Route path="/inventur" element={<Inventory />} />
                <Route path="/inventur/:id" element={<Inventory />} />
                <Route path="/historie" element={<History />} />
                <Route path="/etiketten" element={<Labels />} />
                <Route path="/lagerplan" element={<Lagerplan />} />
                <Route path="/benutzer" element={<UsersAdmin />} />
                <Route path="/einstellungen" element={<Settings />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
